import React from 'react';
import ServicePage from './ServicePage';
import { faMobile } from '@fortawesome/free-solid-svg-icons';
import AppImage from "../assets/app.webp"
import styled from 'styled-components';

const AppCard = styled.div`
  flex: 0 0 43%;
  margin-bottom: 30px;
  padding: ${props => props.padding || '30px'};
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  text-align: ${props => props.align || 'left'};
  
  @media (max-width: 968px) {
    flex: 0 0 90%;
  }
  
  @media (max-width: 576px) {
    flex: 0 0 85%;
  }
  
  h4 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #ff6e6e;
  }
  
  p {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    justify-content: space-around;
  }
  
  @media (max-width: 576px) {
    justify-content: center;
  }
`;

const SectionTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin: ${props => props.margin || '0 0 20px'};
  color: #333;
  text-align: center;
`;

const TechContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  
  @media (max-width: 576px) {
    gap: 15px;
  }
`;

const TechTag = styled.div`
  padding: 15px 25px;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
  font-size: 14px;
  font-weight: 500;
  
  @media (max-width: 576px) {
    padding: 12px 20px;
    font-size: 13px;
  }
`;

const MobileAppDevelopmentPage = () => {
  const features = [
    'Native iOS and Android app development',
    'Cross-platform solutions using React Native and Flutter',
    'User-centered design and intuitive interfaces',
    'Integration with backend systems and APIs',
    'Comprehensive testing across devices',
    'App Store submission and ongoing maintenance'
  ];

  const additionalContent = (
    <div>
      <SectionTitle>
        Our Mobile App Development Approach
      </SectionTitle>
      <CardContainer>
        <AppCard>
          <h4>Native App Development</h4>
          <p>
            We build high-performance native applications for iOS and Android platforms, taking full advantage of device capabilities and platform-specific features to deliver exceptional user experiences.
          </p>
        </AppCard>
        <AppCard>
          <h4>Cross-Platform Solutions</h4>
          <p>
            Our cross-platform development approach using React Native and Flutter allows us to build apps that work seamlessly across multiple platforms while maintaining a native feel and performance.
          </p>
        </AppCard>
        <AppCard>
          <h4>UI/UX Design</h4>
          <p>
            Our design team creates intuitive, engaging user interfaces that enhance user experience and drive app adoption. We focus on creating seamless interactions that align with your brand identity.
          </p>
        </AppCard>
        <AppCard>
          <h4>Backend Integration</h4>
          <p>
            We develop robust backend systems and APIs that power your mobile applications, ensuring seamless data synchronization, user authentication, and integration with third-party services.
          </p>
        </AppCard>
      </CardContainer>
      
      <SectionTitle margin="50px 0 20px">
        App Development Technologies
      </SectionTitle>
      <TechContainer>
        <TechTag>Swift</TechTag>
        <TechTag>Kotlin</TechTag>
        <TechTag>React Native</TechTag>
        <TechTag>Flutter</TechTag>
        <TechTag>Java</TechTag>
        <TechTag>Objective-C</TechTag>
      </TechContainer>
    </div>
  );

  return (
    <ServicePage
      icon={faMobile}
      title="Mobile App Development"
      subtitle="Custom mobile applications designed to engage users, streamline processes, and extend your business reach."
      description={["At Zenitech Solutions, our Mobile App Development services are crafted to bring your ideas to life with high-performance, feature-rich applications for both iOS and Android platforms. We merge cutting-edge technologies with intuitive, user-centric design to build mobile experiences that not only engage users but also accelerate business growth.",

        "From initial concept and strategy to UI/UX design, development, testing, and deployment — we manage the entire app development lifecycle with precision and care. Whether you need a customer-facing app, enterprise solution, or a niche mobile product, our team ensures your app is fast, secure, scalable, and aligned with your brand's goals.",
        
        "With Zenitech Solutions, you get more than just an app — you get a mobile strategy that connects, converts, and creates lasting impact."]}
      features={features}
      imagePath={AppImage}
      additionalContent={additionalContent}
      featuresDesciption="We deliver end-to-end mobile app development solutions tailored to your unique business needs. Our expert team crafts high-quality, user-focused apps with precision and creativity — ensuring seamless performance, stunning design, and attention to every detail for both iOS and Android platforms."
      metaTitle="Mobile App Development Services"
      metaDescription="Our Mobile App Development services are designed to transform your business with cutting-edge, user-centric mobile applications. From concept to deployment, we manage the entire app development lifecycle to deliver high-quality, scalable solutions for iOS and Android platforms."
    />
  );
};

export default MobileAppDevelopmentPage;